import { BrainMark, Card } from "../components/ui";

const TILES = [
  { href: "#/brains", title: "Explore Brains", body: "Browse every Brain: models, miners, validators, stake, and fee splits at a glance.", accent: "var(--pepe)" },
  { href: "#/inference", title: "Chat with a Brain", body: "Pick a Brain, chat multi-turn, verify every response, and pay only the metered cost.", accent: "var(--accent-bright)" },
  { href: "#/account", title: "Spending account", body: "Deposit $basedAI into the market, watch your balance, and withdraw with the safety delay.", accent: "var(--teal)" },
  { href: "#/operate", title: "Operate a Brain", body: "Bring your Brain online, set the model and fee split, and register as a miner or validator.", accent: "var(--magenta)" },
  { href: "#/stake", title: "Stake & earn", body: "Delegate $basedAI to a validator and earn a pro-rata share of its fee yield.", accent: "var(--gold)" },
  { href: "#/api", title: "Bring your agent", body: "Generate a session key and plug any OpenAI-compatible agent into the network.", accent: "var(--accent)" },
];

export function Home() {
  return (
    <>
      <section className="hero">
        <div className="hero-logo">
          <BrainMark size={84} />
        </div>
        <h1>
          based<span className="ai">AI</span>
        </h1>
        <p>
          A decentralized LLM inference network on Ink. Brains are staked NFTs, miners serve GPUs, validators score
          them, and you pay per request in $basedAI — no emissions, no new tokens, just fee-for-service compute.
        </p>
      </section>

      <div className="grid cols-2">
        {TILES.map((t) => (
          <a key={t.href} href={t.href} style={{ textDecoration: "none", color: "inherit" }}>
            <Card>
              <div className="row" style={{ alignItems: "flex-start" }}>
                <div style={{ width: 4, alignSelf: "stretch", background: t.accent, borderRadius: 4 }} />
                <div>
                  <div className="card-title" style={{ marginBottom: 6 }}>
                    {t.title}
                  </div>
                  <div className="muted" style={{ fontSize: 14 }}>
                    {t.body}
                  </div>
                </div>
              </div>
            </Card>
          </a>
        ))}
      </div>

      <div className="section-title">How payment works</div>
      <Card>
        <ol className="muted" style={{ margin: 0, paddingLeft: 18, lineHeight: 1.9, fontSize: 14.5 }}>
          <li>You sign a bounded <strong>pre-authorization</strong> — capped on-chain at the market&apos;s reservation limit, so no miner can ever draw your whole budget up front.</li>
          <li>The gateway routes your prompt to the highest-scored miner, which serves it and proposes a <strong>final receipt</strong> for the delivered output.</li>
          <li>Your browser <strong>verifies</strong> the response hash and re-derives the metered charge from byte counts, independently of the miner.</li>
          <li>You counter-sign the final receipt for the <strong>exact cost</strong>; that is the only thing that authorizes full payment.</li>
        </ol>
      </Card>
    </>
  );
}
